import {html, LitElement} from "../../admin/script/libs/lit.dist.js";
import {cancelDomEvent} from "../../admin/script/util/browser.js";
import {errorAlert} from "../../admin/script/alerts.js";
import {bytesToUnit} from "../util/number.js";

class PkFileInput extends LitElement {

    static get properties() {
        return {
            label: {type: String},
            icon: {type: String},
            accept: {type: String},
            maxsize: {type: Number},
        };
    }

    constructor() {
        super();
        this.accept = '';
        this.label = '';
        this.icon = 'bi bi-plus-circle';
        this.selectedFiles = [];
        this.classList.add('btn');
    }

    async getSelectedFilesBase64() {
        const files = [];
        const promises = Array.prototype.map.call(this.selectedFiles, file => new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                files.push(reader.result);
                resolve();
            };
        }));
        await Promise.all(promises);
        return files;
    }

    handleInput(e) {
        this.selectedFiles = [];

        const maxSize = Number(this.maxsize);
        const validTypes = String(this.accept).split(',');
        for (let file of e.target.files) {
            if (maxSize > 0 && file.size > maxSize) {
                errorAlert(`Plik jest zbyt duży. Maksymalny rozmiar pliku to ${bytesToUnit(maxSize, 0)}`);
                continue;
            }

            if (validTypes.length > 0 && validTypes.indexOf(file.type) === -1) {
                errorAlert(`Nieprawidłowy typ pliku. Prawidłowy typ to ${validTypes.join(', ')}`);
                continue;
            }

            this.selectedFiles.push(file);
        }

        this.dispatchEvent(new Event('input', {bubble: true}));
    }

    render() {
        return html`
            <i class="${this.icon}"></i>
            ${this.label || ''}
            <input
                type="file"
                accept="${this.accept}"
                @input="${cancelDomEvent(e => this.handleInput(e))}"
                class="form-control"
                .title="${this.title}"
            />
        `;
    }

    createRenderRoot() {
        return this;
    }
}

window.customElements.define('pk-file-input', PkFileInput);
